import React, { Component, useEffect, useState, useContext } from 'react';
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import icon_accessibility from "../../../images/234.png";
import { FooterMenu } from '../menu/CirculationMenu';
import apiService from "../../api/apiService";
import CirculationContext from '../../config/CirculationContext';
/**
 * 表尾-公用
 * */
function Common_Footer(props) {
    const ctx = useContext(CirculationContext);
    const [data, setData] = useState({
        mode: 'wait',
        //瀏覽人數
        viewers: '---',
        Last_Update: ctx.Last_Update
    });
    useEffect(function () {

        if (data.mode == 'wait') {
            apiService.getViewers(function (res_data) {
                data.viewers = res_data.data;
                data.mode = 'ok';
                setData({ ...data });

            });
        }

    }, [data]);


    return (
        <>
            <div id="webmap" className="webmap">
                <div className="container-xxl">
                    <div className="row">
                        <FooterMenu />
                    </div>
                </div>
            </div>


            <div className="footer">
                <div className="container-xxl">
                    <div className="linkBox">
                        <div className="detect desktop">
                            <div><a href="https://epamail.moenv.gov.tw/front/mailboxhome" rel="noopener noreferrer" target="_blank" title="意見信箱(另開視窗)">意見信箱</a></div>｜
                            <div><a href="https://www.moenv.gov.tw/Page/E6525EED58F263A3" rel="noopener noreferrer" target="_blank" title="隱私權保護政策(另開視窗)">隱私權保護政策</a></div>｜
                            <div><a href="https://www.moenv.gov.tw/Page/285410B281867E93" rel="noopener noreferrer" target="_blank" title="網站安全政策(另開視窗)">網站安全政策</a></div>｜
                            <div><a href="https://www.moenv.gov.tw/Page/7CED63B63DB9E5DF" rel="noopener noreferrer" target="_blank" title="網站資料開放宣告(另開視窗)">網站資料開放宣告</a></div>｜

                        </div>
                        <div className="detect mobile">
                            <div>
                                <div><a href="https://epamail.moenv.gov.tw/front/mailboxhome" rel="noopener noreferrer" target="_blank" title="意見信箱(另開視窗)">意見信箱</a></div>｜
                                <div><a href="https://www.moenv.gov.tw/Page/E6525EED58F263A3" rel="noopener noreferrer" target="_blank" title="隱私權保護政策(另開視窗)">隱私權保護政策</a></div>｜
                                <div><a href="https://www.moenv.gov.tw/Page/285410B281867E93" rel="noopener noreferrer" target="_blank" title="網站安全政策(另開視窗)">網站安全政策</a></div>
                            </div>
                            <div>
                                <div><a href="https://www.moenv.gov.tw/Page/7CED63B63DB9E5DF" rel="noopener noreferrer" target="_blank" title="網站資料開放宣告(另開視窗)">網站資料開放宣告</a></div>｜

                            </div>
                        </div>
                    </div>
                    <div class="d-flex align-middle">
                        <div className="address mt-3 mb-0 mx-auto justify-content-center justify-content-between">
                            <ul className="list-group list-group-horizontal" style={{ 'listStyleType': 'none' }}>
                                <li className="list-group-item no-border">
                                    <span>第1辦公室</span>｜
                                    <span>地址：100006臺北市中正區中華路一段83號8樓</span>｜
                                    <span>總機電話： (02)2311-7722</span></li>
                            </ul>
                        </div>
                    </div>
                    <div class="d-flex align-middle">
                        <div className="address mt-0 mb-2 mx-auto justify-content-center justify-content-between">
                            <ul className="list-group list-group-horizontal" style={{ 'listStyleType': 'none' }}>
                                <li className="list-group-item no-border">
                                    <span>第2辦公室</span>｜
                                    <span>地址：100005臺北市中正區衡陽路99號13樓</span>｜
                                    <span>總機電話： (02)2370-5888​</span></li>
                            </ul>
                        </div>
                    </div>
                    <div className="copyright">
                        版權所有©2024 環境部資源循環署
                    </div>
                    <div className="suggest">
                        為求最佳瀏覽效果，請使用Chrome 81以上瀏覽器，建議瀏覽解析度1024x768以上 最新更新日期:<span>{data.Last_Update}</span> 瀏覽人次:<span>{data.viewers}</span>
                    </div>
                </div>
                <a title="本網站通過無障礙2_A檢測(開啟新視窗)" target="_blank" rel="noopener noreferrer" href="https://accessibility.moda.gov.tw/Applications/Detail?category=20231006100636">
                    <img  src={icon_accessibility} alt="本網站通過無障礙2_A檢測(開啟新視窗)" />
                </a>
            </div>

        </>);

}

export default Common_Footer;